import styled from "styled-components";

import { FlexDiv } from "../../Atoms";

export const StyledSuccessModal = styled(FlexDiv)`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  flex: 1;
  .image-container {
    width: 100%;
    padding-left: 16px;
    margin-bottom: 16px;
  }
  .text-container {
    flex-direction: column;
    padding: 24px;
  }
  &.webinar-page {
    .image-container {
      padding-left: 0;
      margin-bottom: 0;
    }
    .text-container {
      padding: 24px 8px;
    }
  }
`;

export const ImageHolder = styled(FlexDiv)`
  height: 105px;
  width: 131px;
  border-radius: 0 0 50% 50%;
  overflow: hidden;
  img {
    object-fit: cover;
  }
`;
